import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdenesServiceService {

  constructor(private http:HttpClient) { }

  agregarOrden(form){
    return this.http.post(environment.API_SECURITY+'/api/Ordenes/registrarOrden',form)
  }
  
  agregarOrdenINV(form){
    return this.http.post(environment.API_SECURITY+'/api/Ordenes/invitado',form)
  }

  ordenPorFecha(rangoFecha: any) {
    return this.http.get(environment.API_SECURITY+'/api/Ordenes/ordenesClienteFiltro?'+rangoFecha);
  }

  obtenerCotizacion(data: any) {
    return this.http.post(environment.API_SECURITY+'/api/Envios/Cotizacion',data)
  }

  obtenerCotizacionINV(data: any) {
    return this.http.post(environment.API_SECURITY+'/api/envios/CotizacionInvitado',data)
  }
  
  todasLasOrdenes() {
    return this.http.get(environment.API_SECURITY+'/api/Ordenes/ordenesCliente')
  }

  validarCupon(cupon: any){
    return this.http.post(environment.API_SECURITY+'/api/Cupones/ValidarCupon', cupon)
  }

  
  
  detectCardType(cardNumber: string): string {
    // Eliminar los espacios y verificar si el número tiene al menos 13 caracteres
    cardNumber = cardNumber.replace(/\s/g, '');

    // Obtener los primeros 6 dígitos (BIN)
    const bin = cardNumber.slice(0, 6);

    // Lógica de detección de tipo de tarjeta
    if (/^4[0-9]{5}/.test(bin)) {
      return 'Visa';
    }
    if (/^5[1-5][0-9]{4}/.test(bin) || /^2(22[1-9]|2[3-9][0-9]|[3-9][0-9]{2})[0-9]{3}/.test(bin)) {
      return 'MasterCard';
    }
    if (/^3[47][0-9]{4}/.test(bin)) {
      return 'American Express';
    }
    if (/^60(6333|7289|7469)|^608(014|206)|^604622/.test(bin)) {
      return 'Carnet';
    }
    // if (/^6[0-9]{5}/.test(bin)) {
    //   return 'Discover';
    // }
    // if (/^3(0[0-5]|[68][0-9])[0-9]{4}/.test(bin)) {
    //   return 'Diners Club';
    // }
    // if (/^35[2-8][0-9]{3}/.test(bin)) {
    //   return 'JCB';
    // }

    // Si no se reconoce el BIN
    return 'Desconocido';
  }
  
}
